import { B as BUILD, C as CSS, p as plt, w as win, a as promiseResolve, b as bootstrapLazy } from './index-a1876f0a.js';
import { g as globalScripts } from './app-globals-0f993ce5.js';

/*
 Stencil Client Patch Esm v2.17.3 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    // NOTE!! This fn cannot use async/await!
    // @ts-ignore
    if (BUILD.cssVarShim && !(CSS && CSS.supports && CSS.supports('color', 'var(--c)'))) {
        // @ts-ignore
        return import(/* webpackChunkName: "polyfills-css-shim" */ './css-shim-04165e59.js').then(() => {
            if ((plt.$cssShim$ = win.__cssshim)) {
                return plt.$cssShim$.i();
            }
            else {
                // for better minification
                return 0;
            }
        });
    }
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  globalScripts();
  return bootstrapLazy([["genetic-variants",[[2,"genetic-variants",{"hideId":[4,"hide-id"],"hideLinkVariantBrowser":[4,"hide-link-variant-browser"],"showColumnHideOptions":[4,"show-column-hide-options"],"components":[8],"geneticObservations":[8,"genetic-observations"],"type":[1],"gvTitle":[1,"gv-title"],"tableBackground":[1,"table-background"],"tableHeaderBackground":[1,"table-header-background"],"locale":[1],"localeString":[32],"showId":[32],"showVariantBrowser":[32],"filteredComponents":[32],"showDropdown":[32]}]]],["genomics-report",[[2,"genomics-report",{"fhirBaseUrl":[1,"fhir-base-url"],"idGenomicsReport":[1,"id-genomics-report"],"idImportantVariantsList":[1,"id-important-variants-list"],"token":[1],"tableBackground":[1,"table-background"],"tableHeaderBackground":[1,"table-header-background"],"tableRelevantBackground":[1,"table-relevant-background"],"tableRelevantHeaderBackground":[1,"table-relevant-header-background"],"enableRelevantVariants":[4,"enable-relevant-variants"],"enableAllVariants":[4,"enable-all-variants"],"locale":[1],"metaAsTable":[4,"meta-as-table"],"hideLinkVariantBrowser":[4,"hide-link-variant-browser"],"changedRelevant":[32],"localeString":[32]},[[0,"changeRelevant","handleChangeRelevant"]]]]]], options);
  });
};

export { defineCustomElements };
